import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useAccounts } from '@/features/accounts/accounts.hooks';
import AccountsTable from '@/features/accounts/accounts.table';

export const AccountsPanel = ({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  const resource = useAccounts();
  return (
    <Panel {...panelProps}>
      <AccountsTable {...resource} />
    </Panel>
  );
};
